import { render, staticRenderFns } from "./LdpLoiNhan.vue?vue&type=template&id=3667d966&scoped=true&"
import script from "./LdpLoiNhan.vue?vue&type=script&lang=js&"
export * from "./LdpLoiNhan.vue?vue&type=script&lang=js&"
import style0 from "./LdpLoiNhan.vue?vue&type=style&index=0&id=3667d966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667d966",
  null
  
)

export default component.exports